import { ref, onMounted, onUnmounted, Ref } from '@nuxtjs/composition-api';

export default function useActiveLink (links: { href: string, text: string }[]) : { activeLink: Ref<string | null> } {

  const activeLink = ref<string | null>(null);
  const options: IntersectionObserverInit = { root: null, rootMargin: '-40% 0px -50% 0px', threshold: 0.01 };
  let observer: IntersectionObserver | null = null;

  const observeLinks = () => {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          activeLink.value = `#${entry.target.id}`;
        }
      });
    }, options);

    links.forEach((item) => {
      const element = document.querySelector(item.href);
      if (element) observer.observe(element);
    });
  };

  onMounted(() => {
    observeLinks();
  });

  onUnmounted(() => {
    observer?.disconnect();
  });

  return {
    activeLink
  };
}
